import {
	isValidationError,
	type ValidationError,
} from '@atlassian/jira-fetch/src/utils/errors.tsx';
import genericError from './generic-error/index.tsx';
import validationError from './validation-error/index.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (error: Error) =>
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	isValidationError(error) ? validationError((error as ValidationError).errors) : genericError();
